import { Controller } from "@hotwired/stimulus"

export default class FilmstripController extends Controller {
  static targets = ["container", "prevButton", "nextButton", "item"]

  connect() {
    this.updateNavigationVisibility()
  }

  disconnect() {
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout)
    }
  }

  onScroll() {
    clearTimeout(this.scrollTimeout)

    this.scrollTimeout = setTimeout(() => {
      this.updateNavigationVisibility()
    }, 16)
  }

  scrollLeft() {
    this.containerTarget.scrollBy({
      left: this.#itemWidth() * -1,
      behavior: "smooth",
    })
  }

  scrollRight() {
    this.containerTarget.scrollBy({
      left: this.#itemWidth(),
      behavior: "smooth",
    })
  }

  updateNavigationVisibility() {
    const container = this.containerTarget
    const scrollLeft = container.scrollLeft
    const maxScroll = container.scrollWidth - container.clientWidth

    this.prevButtonTarget.style.opacity = scrollLeft > 0 ? "1" : "0"
    this.nextButtonTarget.style.opacity = scrollLeft < maxScroll ? "1" : "0"
  }

  #itemWidth() {
    return this.itemTargets[0]?.offsetWidth || this.containerTarget.clientWidth
  }
}
